<template>
  <div class="px-20">
    <router-link :to="item.routerLinkTo" @click.native="trackEvent()">
      <entity-image
        :type="entityImageTypes[index % entityImageTypes.length]"
        :src="item.imageUrl"
        size="height-fixed--240"
        class="width-100"
      />
      <h3 class="text-center mt-20">
        {{ item.title }}
      </h3>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
    index: {
      type: Number,
    },
    trackEventDataAccessor: {
      type: Function,
    },
  },
  data() {
    return {
      entityImageTypes: ["round-none", "round-sm", "retailer"],
    };
  },
  methods: {
    trackEvent
  }
};

function trackEvent(){
  this.$ma.trackEvent(this.trackEventDataAccessor(this.item))
}

</script>
